// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IEyeColorType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class EyeColorType implements IEyeColorType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Black EyeColorType
	**/
    get BLK(): IEyeColorType {
        return this.FromId(1);
    }
    /**
		Returns Blue EyeColorType
	**/
    get BLU(): IEyeColorType {
        return this.FromId(2);
    }
    /**
		Returns Brown EyeColorType
	**/
    get BRO(): IEyeColorType {
        return this.FromId(3);
    }
    /**
		Returns Dichromatic EyeColorType
	**/
    get DIC(): IEyeColorType {
        return this.FromId(4);
    }
    /**
		Returns Green EyeColorType
	**/
    get GRN(): IEyeColorType {
        return this.FromId(5);
    }
    /**
		Returns Gray EyeColorType
	**/
    get GRY(): IEyeColorType {
        return this.FromId(6);
    }
    /**
		Returns Hazel EyeColorType
	**/
    get HAZ(): IEyeColorType {
        return this.FromId(7);
    }
    /**
		Returns Maroon EyeColorType
	**/
    get MAR(): IEyeColorType {
        return this.FromId(8);
    }
    /**
		Returns Pink EyeColorType
	**/
    get PNK(): IEyeColorType {
        return this.FromId(9);
    }
    /**
		Returns Unknown EyeColorType
	**/
    get UNK(): IEyeColorType {
        return this.FromId(10);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'BLK', displayValue: 'Black', description: 'Black', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'BLU', displayValue: 'Blue', description: 'Blue', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'BRO', displayValue: 'Brown', description: 'Brown', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'DIC', displayValue: 'Dichromatic', description: 'Dichromatic', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'GRN', displayValue: 'Green', description: 'Green', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'GRY', displayValue: 'Gray', description: 'Gray', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'HAZ', displayValue: 'Hazel', description: 'Hazel', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'MAR', displayValue: 'Maroon', description: 'Maroon', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'PNK', displayValue: 'Pink', description: 'Pink', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'UNK', displayValue: 'Unknown', description: 'Unknown', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IEyeColorType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IEyeColorType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IEyeColorType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IEyeColorType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IEyeColorType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
